export const orderTeams = (teams)=>{
    function compareFn(a, b) {
        //cuando tiene mas puntos
        if ((b?.partidosGanados*3 + b?.partidosEmpatados)<(a?.partidosGanados*3 + a?.partidosEmpatados)) {
          return -1;
        } else if ((b?.partidosGanados*3 + b?.partidosEmpatados)>(a?.partidosGanados*3 + a?.partidosEmpatados)) {
          return 1;
        }
        //Cuando empatan en puntos
        if((b?.partidosGanados*3 + b?.partidosEmpatados)===(a?.partidosGanados*3 + a?.partidosEmpatados) && ((b?.golesFavor - b?.golesContro)>(a?.golesFavor - a?.golesContro))) return 1
        if((b?.partidosGanados*3 + b?.partidosEmpatados)===(a?.partidosGanados*3 + a?.partidosEmpatados) && ((b?.golesFavor - b?.golesContro)<(a?.golesFavor - a?.golesContro))) return -1
        //Cuando empatan en goles y puntos
        if((b?.partidosGanados*3 + b?.partidosEmpatados)===(a?.partidosGanados*3 + a?.partidosEmpatados) && ((b?.golesFavor - b?.golesContro)===(a?.golesFavor - a?.golesContro)) && (b?.golesFavor > a?.golesFavor)) return 1
        if((b?.partidosGanados*3 + b?.partidosEmpatados)===(a?.partidosGanados*3 + a?.partidosEmpatados) && ((b?.golesFavor - b?.golesContro)===(a?.golesFavor - a?.golesContro)) && (b?.golesFavor < a?.golesFavor)) return -1
        return 0;
      }
    return teams.sort(compareFn)

}

export function compareTeams (a,b) {
  //flujo cuando los equipos tienen mas puntos
  if(b?.TotalPuntos < a.TotalPuntos){
    return -1
  }else if(b?.TotalPuntos > a?.TotalPuntos) return 1

  //flujo cuando tienen los mismo puntos pero ahora por goles
  if((b?.TotalPuntos === a?.TotalPuntos) && ((b?.TotalGolesA - b?.TotalGolesC) > (a?.TotalGolesA - a?.TotalGolesC) )) return 1
  if((b?.TotalPuntos === a?.TotalPuntos) && ((b?.TotalGolesA - b?.TotalGolesC) < (a?.TotalGolesA - a?.TotalGolesC) )) return -1

  //flujo cuando tienen la misma diferencia de goles
  if(b?.TotalGolesA > a?.TotalGolesA) return 1
  if(b?.TotalGolesA < a?.TotalGolesA) return -1

  //flujo cuando se tiene los mismo goles a favor
  if(b?.TotalGolesC < a?.TotalGolesC) return 1
  if(b?.TotalGolesC > a?.TotalGolesC) return -1

  return 0

}